import { IUserPassport } from "Bands/types";
import { upperFirst } from "lodash-es";
import React, { useMemo } from "react";

import { TeaserProps } from "shared/components";
import { DocumentTeaser } from "./DocumentTeaser";

interface PassportTeaserProps extends IUserPassport, TeaserProps {}

export const PassportTeaser: React.FC<PassportTeaserProps> = ({ title, documentType, ...rest }) => {
  const teaserTitle = useMemo(
    () =>
      `${upperFirst(
        documentType.replaceAll("_", " ").replaceAll("id", "ID").replaceAll("card", "Card")
      )} ${title ? `(${title})` : ""} `,
    [documentType, title]
  );

  return <DocumentTeaser {...rest} title={teaserTitle} />;
};
